import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecurityAuditSecretsWithAgeGroups } from '../services/selectors';

export const useSecurityAuditAgeSecretsList = () => useAppSelector(selectSecurityAuditSecretsWithAgeGroups);
